<template>
	<v-main>
		<v-layout fill-height column>
			<v-container fluid flex-fill>
			</v-container>

		</v-layout>
		<TermsSheet :sheet="sheet" @sheetClose="sheetClose" @termsDetailsOpen="termsDetailsOpen" @joinNext="joinNext"/>
		<TermsDetailsModal :dialog="termsDetailsDialog" :flag="termsFlag" @close="termsDetailsDialog = false"/>
	</v-main>
</template>
<script>
import TermsSheet from "@/components/layout/bottomSheet/TermsSheet.vue";
import TermsDetailsModal from "@/components/terms/TermsDetailsModal.vue";
import store from "@/store";

export default {
	data: () => ({
		sheet: true,
		termsDetailsDialog: false,
		termsFlag: null,
		usetermsApplyYn: false,
		privacyApplyYn: false,
		mktRecvApplyYn: false,
		smsRecvYn: 'N',
		emailRecvYn: 'N',
		division:null,

	}),
	mounted() {
		this.division = (store.getters.clientCd==='') ? '02' : (!this.$route.params.division) ? "01" : this.$route.params.division;
	}
	,components: {
		TermsSheet,
		TermsDetailsModal,
	},
	methods: {

		next() {
			/* 약관 시트 */
			this.sheet = true;
		},
		sheetClose() {
			this.sheet = false;
		},
		termsDetailsOpen(index) {
			this.termsFlag = index;
			this.termsDetailsDialog = true;
		},
		joinNext(terms,sms,email) {
			this.usetermsApplyYn = terms[0]; // 약관동의
			this.privacyApplyYn = terms[1];  // 개인정보
			this.mktRecvApplyYn = terms[2];  // 마케팅

			if(sms) this.smsRecvYn = 'Y'
			if(email) this.emailRecvYn = 'Y'


      let setData = {
        division: this.division,
        usetermsApplyYn : this.usetermsApplyYn ? 'Y' : 'N',
        privacyApplyYn : this.privacyApplyYn ? 'Y' : 'N',
        mktRecvApplyYn : this.mktRecvApplyYn ? 'Y' : 'N',
        smsRecvYn : this.smsRecvYn,
        emailRecvYn : this.emailRecvYn,
        memberGb: this.division
      }
      store.commit('setJoinUser', setData)
			//01 기업회원(무/명부형), 02 일반회원
      if(this.division === '01' && !store.getters.clientCd) {
        this.$router.push({name: '기업회원 인증'})
      } else {
        this.$router.push({name:"휴대폰 인증"})
      }
		}
	}
}
</script>
<style lang="scss" scoped>
.logo {
	text-align: center;
	padding: 25px 0 60px;
}
.line {
	width:1px;
	height: 12px;
	background: #9FA3A8;
	margin: 0 12px;
}
.dot {
	width: 3px;
	height: 3px;
	border-radius: 50%;
	background: #9FA3A8;
	margin: 0 6px;
}
.content-footer {
	padding: 0 20px;
	flex-direction: column;
	height: auto !important;
	&__head{
		position: relative;
		text-align: center;
		span{
			position: relative;
			color: $color-gray-3 ;
			background: #fff;
			padding: 0 8px;
			z-index: 1;
			font-size: 14px;
		}
		&:after {
			position: absolute;
			display: inline-block;
			content: '';
			width: 100%;
			height: 1px;
			top: 50%;
			left: 0;
			background: #E6E8EA;

		}
	}
	&__contents{
		display: flex;
		justify-content: center;
		gap: 16px;
		padding: 30px 0 60px;
	}
}
</style>
